































import Vue from 'vue';
import CustomType from '../../src/types/vue';
import Langue from '../../src/components/Langue.vue';
import CompteARebours from '../../src/components/CompteARebours.vue';

export interface ComponentApp extends Vue {
  locale: string
}

var component: Vue.ComponentOptions<ComponentApp> = {
  name: 'Header',
  props: {
  },
  data () {
    return {
         langues: this.$store.state.locales,
    }
  },
  methods: {
    scroll: function(){
      window['clemsouzScroller']('form', 600);
    },
    dlplaquette: function(){
      window.open('./img/plaquette-'+this.locale+'.pdf')
    },
    dlpresse: function(){
      window.open('./img/presse-'+this.locale+'.pdf')
    }
  },
  computed: {
    locale: function(){
      return this.$store.state.locale
    }
  },
  components: {
    Langue,
    CompteARebours
  },
  mounted: function() {

  }
}

export default component;



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/modules/Header.vue